import { Button, Form, message } from 'antd'
import { DocumentData } from 'Modules'
import { useCallback, useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { FEATURE } from 'constants/feature'
import { usePTOV3Context } from 'context/pto-v3-context-provider'
import { usePermission } from 'hooks/use-permission'
import Documents from 'modules/pto-v3/document/documents'
import Properties from 'modules/pto-v3/document/properties'
import { logError } from 'utils/logger'

const Document = () => {
  const { code } = usePTOV3Context()

  const { canCRUD } = usePermission()
  const canEdit = canCRUD(FEATURE.PTO)

  const [edit, setEdit] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [documentDetails, setDocumentDetails] = useState<DocumentData>({
    //timeLines: [],
    documentDetail: [],
    financial: [],
  })

  const [formDocumentDetail] = Form.useForm()

  const getDocumentDetails = useCallback(async () => {
    if (!code) return
    try {
      const res = await AppAdmin.getDocumentDetailsPTO(code)

      if (res?.data.success) {
        setDocumentDetails({
          documentDetail: res?.data.data.documentDetail,
          financial: res?.data.data.financial,
          //timeLines: res?.data.data.timeLines
        })
        formDocumentDetail.setFieldsValue(res?.data.data) // Set initial form values
      } else {
        setDocumentDetails({
          //timeLines: [],
          documentDetail: [],
          financial: [],
        })
        formDocumentDetail.resetFields()
      }
    } catch (error) {
      setDocumentDetails({
        //timeLines: [],
        documentDetail: [],
        financial: [],
      })
      formDocumentDetail.resetFields()
      logError('Error: ', error)
    }
  }, [code, formDocumentDetail])

  const handleUpdateDocument = async () => {
    setLoading(true)
    try {
      const values = await formDocumentDetail.validateFields()
      const documentDetail = [...documentDetails.documentDetail]

      const formData = new FormData()
      const indicesToUpdate: number[] = []

      documentDetails.documentDetail.forEach((file, index) => {
        if (file.document) {
          // New document to upload
          formData.append('files', file.document as any)
          indicesToUpdate.push(index)
          delete file.document
        } else if (file.document === null) {
          // Document was explicitly deleted, clear the link
          documentDetail[index].link = ''
        }
      })

      if (formData.get('files')) {
        const res = await AppAdmin.uploadMultipleFiles(formData)

        res.data.data.forEach((file: any, i: number) => {
          documentDetail[indicesToUpdate[i]].link = file.filePath
        })
      }

      await AppAdmin.documentCreatePTO({
        ...values,
        tokenize: code,
        documentDetail,
      })
      message.success('Document updated successfully!')
      setDocumentDetails({
        documentDetail: [],
        financial: [],
      })
      // formDocumentDetail.resetFields();
      getDocumentDetails()
    } catch (error: any) {
      setDocumentDetails({
        //timeLines: [],
        documentDetail: [],
        financial: [],
      })
      formDocumentDetail.resetFields()
      message.error(error?.message ? error?.message : 'Error while submitting form')
      logError('Error while submitting form:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    getDocumentDetails()
    setEdit(false)
  }

  const handleSubmit = () => {
    handleUpdateDocument()
    handleCancel()
  }

  useEffect(() => {
    getDocumentDetails()
  }, [code, getDocumentDetails])

  return (
    <div className="p2p-create">
      <Form onFinish={handleSubmit} form={formDocumentDetail} layout="vertical">
        <div style={{ textAlign: 'start', paddingBottom: 10 }}>
          {!edit && !loading ? (
            <Button
              style={{ marginRight: 15, width: 100 }}
              key="edit"
              onClick={() => setEdit(true)}
              type="primary"
            >
              {documentDetails?.documentDetail?.length < 1 && documentDetails?.financial?.length < 1
                ? //&& documentDetails.timeLines.length < 1
                  'Create'
                : 'Edit'}
            </Button>
          ) : (
            <>
              {!loading && (
                <Button style={{ marginRight: 15, width: 100 }} key="back" onClick={handleCancel}>
                  Cancel
                </Button>
              )}
              <Button
                style={{ width: 100 }}
                disabled={!canEdit}
                key="submit"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Save
              </Button>
            </>
          )}
        </div>
        <Properties edit={edit} />
        <Documents
          edit={edit}
          documentDetails={documentDetails}
          setDocumentDetails={setDocumentDetails}
        />
      </Form>
    </div>
  )
}

export default Document
